require('./rulesBrowser.i18n.json');
require('./rulesBrowser.tpl.html');
require('./rulesBrowserActionRepository.js');
require('./redeployRuleSets/redeployRuleSets.i18n.json');
require('./redeployRuleSets/redeployRuleSets.tpl.html');
require('./redeployRuleSets/redeployRuleSetsController.js');

/*@ngInject*/
const RulesBrowserController = function ($scope, $uibModal, $filter, advancedFilterType, configurationMediator, filterType, localization, modalUtil, ruleAction, ruleUtil, configurationActionsUtil, databaseDownloadSectionName) {

    localization.getTranslationByKey('rulesBrowser').then(function (translations) {

        $scope.columns = [{
            name: 'name',
            label: _.get(translations, 'columns.name'),
            className: 'colName',
            getValue: function (item) {
                return item.name;
            }
        }, {
            name: 'ruleSetName',
            label: _.get(translations, 'columns.ruleSet'),
            className: 'colRuleSet',
            getValue: function (item) {
                return item.ruleSetName;
            }
        }, {
            name: 'tags',
            label: _.get(translations, 'columns.tags'),
            className: 'colTags',
            getColumnItems: function (item) {
                return item.tags;
            },
            getValue: function (item) {
                return item.name;
            },
            isTag: function (item) {
                return true;
            }
        }, {
            name: 'priority',
            label: _.get(translations, 'columns.priority'),
            className: 'colPriority',
            getValue: function (item) {
                return item.priority;
            }
        }, {
            name: 'status',
            label: _.get(translations, 'columns.status'),
            className: 'colStatus',
            getValue: function (item) {
                return _.get(translations, 'status.' + item.status);
            }
        }, {
            name: 'lastModifiedBy',
            label: _.get(translations, 'columns.lastModifiedBy'),
            className: 'colLastModifiedBy',
            getValue: function (item) {
                return item.lastModifiedBy;
            }
        }, {
            name: 'timeLastModified',
            label: _.get(translations, 'columns.timeLastModified'),
            className: 'colTimeLastModified',
            getValue: function (item) {
                return $filter('date')(item.timeLastModified, 'MM/dd/yy hh:mma');
            }
        }];

        $scope.advancedFilterType = advancedFilterType.RULES_BROWSER;
        $scope.filterType = filterType.TYPE_RULE_FILTER;

        $scope.stateParams = {
            browser: 'configuration.rulesBrowser',
            getDetailState: function (rule) {
                return {
                    name: 'configuration.ruleBuilder',
                    params: {
                        ruleId: rule.id,
                        ruleSetName: rule.ruleSetName
                    }
                };
            }
        };

        $scope.translations = {
            title: _.get(translations, 'title'),
            recordCountText: _.get(translations, 'recordCountText'),
            recordsCountText: _.get(translations, 'recordsCountText'),
            emptyGrid: _.get(translations, 'emptyGrid')
        };

        $scope.initialRequestParams = {
            key: 'name',
            startIndex: 0,
            pageSize: 25,
            sortType: 'asc'
        };

        $scope.loadActionsHandler = function () {
            return configurationMediator.loadRulesBrowserActions();
        };

        $scope.loadItemsHandler = function (filterUri, requestParams) {
            return configurationMediator.getRulesByFilterUri(filterUri, requestParams);
        };

        $scope.handleAction = function (action, file) {
            if (action.enabled) {
                switch (action.name) {
                    case ruleAction.NEW_RULE:
                        $uibModal.open({
                            templateUrl: '/configuration/ruleTemplateSettings/ruleTemplateSettings.tpl.html',
                            controller: 'ruleTemplateSettingsController',
                            windowClass: 'ruleTemplateSettingsModal',
                            resolve: {
                                options: {
                                    ruleTemplateId: null
                                }
                            }
                        });
                        break;

                    case ruleAction.REDEPLOY:
                        ruleUtil.redeployRuleSets();
                        break;
                    case ruleAction.BACKUP:
                        configurationActionsUtil.backup(databaseDownloadSectionName.RULE_SETS, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
                        break;
                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };
    });
};

angular.module('ums.configuration')
    .controller('rulesBrowserController', RulesBrowserController);
